export const checkVoulumeLevel = (arr, uid) => {
  let d = arr?.find((x) => x.uid == uid);
  if (d?.uid) {
    return { status: true, level: d.level };
  } else {
    return { status: false, level: 0 };
  }
};
